import { FieldType, MediaPublicationInfoField } from '../../../../components/GenericSection';
var SEEN_PUBINFO_SECTION_FIELDS = [{
  field: MediaPublicationInfoField.MEDIUM,
  labelText: 'Medium',
  recommended: false,
  type: FieldType.TEXT
}, {
  fields: [{
    field: MediaPublicationInfoField.PUBLISHER,
    labelText: 'Publisher',
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: MediaPublicationInfoField.PUBLISHER_LOCATION,
    labelText: 'Location',
    recommended: true,
    type: FieldType.TEXT
  }]
}];
export default SEEN_PUBINFO_SECTION_FIELDS;